'use client';
import type { ReactNode } from 'react';
import { twMerge } from 'tailwind-merge';
import Link from 'next/link';
import { usePath } from '@/hooks/usePath';
import { classes, getStateClass, isActive, styles } from './utils';

export type SidebarButtonProps = {
  disabled?: boolean;
  href: string;
  label: string;
  icon: ReactNode;
  color?: string;
  bgColor?: string;
};

export default function SidebarButton({
  href,
  label,
  icon,
  disabled,
  color,
  bgColor,
}: SidebarButtonProps) {
  const { pathname, searchParams } = usePath();

  const renderContent = () => (
    <>
      <span className={classes.icon}>{icon}</span>
      <span className={classes.label}>{label}</span>
    </>
  );

  if (disabled) {
    return (
      <div className={twMerge(classes.button, classes.disabled)}>
        {renderContent()}
      </div>
    );
  }

  const isButtonActive = isActive(href, pathname);
  const hasCustomColor = isButtonActive && !!bgColor;

  return (
    <Link
      style={hasCustomColor ? styles.active(color, bgColor) : undefined}
      className={twMerge(
        classes.button,
        getStateClass(isButtonActive, hasCustomColor)
      )}
      href={`${href}?${searchParams.toString()}`}>
      {renderContent()}
    </Link>
  );
}
